import { Prismic__LinkableWithType } from 'types/prismicLink';
import { PrismicRichText } from 'types/prismicRichtext';
import { PrismicImage } from 'types/prismicImage';
import {
  Prismic_Article,
  Prismic_Association,
  Prismic_Page,
  Prismic_Project,
  Prismic_External_Cta,
} from 'types/prismic';
import { PlaceholderColor  } from 'types/placeholderColors';

import { linkResolver } from './linkResolver';

interface IPrismicTypeData {
  text: PrismicRichText;
  link: string | null;
  backgroundColor: PlaceholderColor;
  image: PrismicImage;
  article: Prismic_Article | null;
  page: Prismic_Page | null;
  project: Prismic_Project | null;
  association: Prismic_Association | null;
  externalCta: Prismic_External_Cta | null
}

/**
 * Get and map data from a Linkable item in Prismic. Will return shared data between the types
 * (text, link, image) and the specific types (article, page).
 * Linkable item in Prismic comes from the relationship type.
 *
 * @param item Linkable item to get data from
 * @returns IPrismicTypeData Data found in item, or every key as null
 */
export function getTypeDataFromLinkable(item: Prismic__LinkableWithType): IPrismicTypeData {
  let text: PrismicRichText = null;
  let link: any = null;
  let backgroundColor: any = '';
  let image: PrismicImage = null;
  let article: Prismic_Article | null = null;
  let page: Prismic_Page | null = null;
  let project: Prismic_Project | null = null;
  let association: Prismic_Association | null = null;
  let externalCta: Prismic_External_Cta | null = null;

  switch (item?.__typename! ?? '') {
    case 'PRISMIC_Article':
    case 'Article':
      const itemAsArticle = item as Prismic_Article;
      text = itemAsArticle.title as PrismicRichText;
      link = itemAsArticle;
      image = itemAsArticle.image;
      article = itemAsArticle;
      break;
    case 'PRISMIC_Page':
    case 'Page':
      const itemAsPage = item as Prismic_Page;
      text = itemAsPage.title;
      link = itemAsPage;
      page = itemAsPage;
      break;
    case 'PRISMIC_Project':
    case 'Project':
      const itemAsProject = item as Prismic_Project;
      text = itemAsProject.title;
      link = itemAsProject;
      project = itemAsProject;
      break;
    case 'PRISMIC_Association':
    case 'Association':
      const itemAsAssociation = item as Prismic_Association;
      text = itemAsAssociation.title;
      link = itemAsAssociation;
      association = itemAsAssociation;
      break;
    case 'PRISMIC_External_cta':
    case 'ExternalCta':
      const itemAsExternalCta = item as Prismic_External_Cta;
      text = itemAsExternalCta.title;
      backgroundColor = itemAsExternalCta.background_color;
      link = itemAsExternalCta.link;
      externalCta = itemAsExternalCta;
      break;
    default:
      break;
  }

  return {
    text,
    link: linkResolver(link),
    image,
    article,
    backgroundColor,
    page,
    project,
    association,
    externalCta,
  };
}
